import { getRequest } from '../services/requestHandler';
import { DeletedTourBag } from '../models';

//5537, 3 for testing
export const getDeletedTourBagClubs = async (playerId: number, headTypeId: number) => {
  const url = `tourbag/getdeletedtourbagclubs?playerid=${playerId}&headTypeId=${headTypeId}`;
  const response = await getRequest<DeletedTourBag>('DeletedTourBag', url);
  return response;
};
